const Lock = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0002 1.66675C7.69898 1.66675 5.8335 3.53223 5.8335 5.83341V7.50008H5.00016C4.07969 7.50008 3.3335 8.24627 3.3335 9.16675V16.6667C3.3335 17.5872 4.07969 18.3334 5.00016 18.3334H15.0002C15.9206 18.3334 16.6668 17.5872 16.6668 16.6667V9.16675C16.6668 8.24627 15.9206 7.50008 15.0002 7.50008H14.1668V5.83341C14.1668 3.53223 12.3013 1.66675 10.0002 1.66675ZM12.5002 7.50008V5.83341C12.5002 4.4527 11.3809 3.33341 10.0002 3.33341C8.61945 3.33341 7.50016 4.4527 7.50016 5.83341V7.50008H12.5002ZM10.0002 10.8334C10.4604 10.8334 10.8335 11.2065 10.8335 11.6667V14.1667C10.8335 14.627 10.4604 15.0001 10.0002 15.0001C9.53993 15.0001 9.16683 14.627 9.16683 14.1667V11.6667C9.16683 11.2065 9.53993 10.8334 10.0002 10.8334Z"
      fill="currentColor"
    />
  </svg>
)
export default Lock
